/**
 * Formats a number into a compact, human-readable string representation.
 *
 * @param count - The number to format
 * @returns A formatted string with compact notation (e.g., 1K, 1.5M)
 * @example
 * // Returns "1K"
 * formatCount(1000)
 *
 * // Returns "1.5K"
 * formatCount(1500)
 *
 * // Returns "1M"
 * formatCount(1000000)
 */
export const formatCount = (count: number): string => {
  return Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(count)
}
